var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon Station Business",
    viewBox: "0 0 10 20.002",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i-publicstation-1{fill:currentColor}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i-publicstation-1",
    transform: "translate(-.001)",
    d: "M5 20a5.006 5.006 0 0 1-5-5h10a5.006 5.006 0 0 1-5 5zm5-7H0V0h5a5.005 5.005 0 0 1 5 5v8zM5.056 2.8a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5z",
    "data-name": "Differenzmenge 22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessStation);
export default __webpack_public_path__ + "static/media/businessStation.cf27310273a13c6fdd99b8d686d2b4a2.svg";
export { ForwardRef as ReactComponent };